import Image from 'next/image';
import React from 'react';

export const SynchronyLogoWhite = () => {
  return <Image height={179.37} src="/logos/light.png" width={326} />;
};
